import React from 'react'
import { Dialog, DialogTitle, DialogContent, DialogContentText, Button, DialogActions } from '@mui/material';


const UploadDialog = ({openModal, setOpenModal, uploadFile, goToNextStep, selectedFile }) => {
  return (
    <Dialog
  open={openModal}
  onClose={() => setOpenModal(false)}
  aria-labelledby="alert-dialog-title"
  aria-describedby="alert-dialog-description"
>
  <DialogTitle id="alert-dialog-title">{"File already exists"}</DialogTitle>
  <DialogContent>
    <DialogContentText id="alert-dialog-description">
      This file already exists. Do you want to upload a new version?
    </DialogContentText>
  </DialogContent>
  <DialogActions>
    <Button onClick={() => {
      // Lógica para "Upload"
      uploadFile(selectedFile).then(() => {
        setOpenModal(false);
        goToNextStep();
      });
    }}>Upload</Button>
    <Button onClick={() => {
      // Lógica para "Proceed Without Upload"
      setOpenModal(false);
      goToNextStep();
    }} color="primary" autoFocus>
      Proceed Without Upload
    </Button>
    <Button onClick={() => {
      // Lógica para "Cancel"
      setOpenModal(false);
    }} color="secondary">
      Cancel
    </Button>
  </DialogActions>
</Dialog>

  )
}

export default UploadDialog